import type { FC } from 'react'
import { useCallback } from 'react'

import useBoolean from '../../hooks/use-boolean'

const ToggleStateProvider: FC<
  { initialState?: boolean } & {
    children: (props: {
      value?: boolean
      handler: (value?: boolean) => () => void
    }) => JSX.Element
  }
> = props => {
  const { initialState, children } = props
  const [value, action] = useBoolean(initialState)

  const handler = useCallback(
    (value?: boolean) => () =>
      typeof value === 'boolean' ? action.toggle(value) : action.toggle(),
    [action]
  )
  return children({ value, handler })
}

export default ToggleStateProvider
